module.exports = __webpack_public_path__ + "img/2-4.04afa31e.png";